import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import Message from '../components/Message';
import {
  useRegisterMutation,
  useGetUserProDetailsQuery,
  useGetManagersQuery,
} from '../slices/usersApiSlice';
import { setCredentials } from '../slices/authSlice';
import { toast } from 'react-toastify';
import { useGetDirectoratesNoPageQuery } from '../slices/directoratesApiSlice.js';
import { useGetCostcentresNoPageQuery } from '../slices/costcentresApiSlice.js';

//#f5f5dc
const dropdownStyle = {
  backgroundColor: '#F5F5F5', //'#F0E68C'                 //'lightyellow',
  // Add other styles as needed
};
const textStyle = {
  backgroundColor: '#f5f5dc',
  // Add other styles as needed
};

const RegisterScreen = () => {
  const [availableContractTypes, setAvailableContractTypes] = useState([]);
const [userType, setUserType] = useState('staff'); // or 'agency'

  const [name, setName] = useState('-');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');

  const [employeenumber, setEmployeenumber] = useState('');
  const [jobtitle, setJobtitle] = useState('');
  const [speciality, setSpeciality] = useState('');
  const [specialityID, setSpecialityID] = useState('');

  //const [subspeciality, setSubspeciality] = useState('');
  //const [location, setLocation] = useState('');
  const [directoratedepartment, setDirectoratedepartment] = useState('');
  const [directorateID, setDirectorateID] = useState('');

 // const [primaryemployer, setPrimaryemployer] = useState(false);
  //const [yourclinicaldirector, setYourclinicaldirector] = useState('');
  //const [yourclinicaldirectorID, setYourclinicaldirectorID] = useState('');
  //const [contracttype, setContracttype] = useState('');
  //const [approvedtrainer, setApprovedtrainer] = useState(false);
  //const [areyouaclinicaldirector, setAreyouaclinicaldirector] = useState(false);
  //const [oncallcommitmentYN, setOncallcommitmentYN] = useState(false);
  //const [oncallcommitmentcomment, setOncallcommitmentcomment] = useState('--');

  //_____________________________________________________________________________________________________________________
  //const [occupationallyExposedYN, setOccupationallyExposedYN] = useState(false);
  //const [occupationallyExposedComment, setOccupationallyExposedComment] =    useState('--');
 // const [ionisingRadiationProceduresYN, setIonisingRadiationProceduresYN] =    useState(false);
 // const [
 //   ionisingRadiationProceduresComment,
  //  setIonisingRadiationProceduresComment,
  //] = useState('--');
  //const [useOfLasersYN, setUseOfLasersYN] = useState(false);
  //const [useOfLasersComment, setUseOfLasersComment] = useState('--');

  //const [buckleycontract, setBuckleycontract] = useState('');
  const [comment, setComment] = useState('--');
  const [effectiveDate, setEffectiveDate] = useState(new Date());
  const [reviewDate, setReviewDate] = useState(new Date());
  const [salutation, setSalutation] = useState('--');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [register, { isLoading }] = useRegisterMutation();

  const {
    data: directoratesdata,
    isLoading: isLoadingD,
    error: errorD,
    refetch: refetchD,
  } = useGetDirectoratesNoPageQuery();
  const {
    data: costcentresdata,
    isLoading: isLoadingBC,
    error: errorBC,
    refetch: refetchBC,
  } = useGetCostcentresNoPageQuery();

  const { userInfo } = useSelector((state) => state.auth);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get('redirect') || '/';

  const {
    data: managers,
    refetch: refetchM,
    isLoading: isLoadingM,
    error: errorM,
  } = useGetManagersQuery();

  //console.log("RegisterScreen : managers ", managers);

  // Define the options data
  const contractData = {
    'Public Only Consultant Contract': [
      'POCC Clinician',
      'POCC Academic Professor',
      'POCC Associate Professor',
      'POCC Senior Lecturer',
    ],
    '2008 Contract': [
      'Type A',
      'Type B',
      'Type B Academic',
      'Type B*',
      'Type B* Academic',
      'Type C',
      'Type C Academic',
    ],
    'Buckley Contract': [
      'Category I',
      'Category II',
      'Category II Senior Lecturer',
    ],
  };

  

useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }

    
  }, [navigate, redirect, userInfo]);

   

  const submitHandler = async (e) => {
    e.preventDefault();

    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
    }  else {
      toast.success('updateing profile ');

      try {
        setName(firstname);
        const res = await register({
          name,
          email,
          password,
          employeenumber,
          firstname,
          lastname,
          jobtitle,
          speciality,
          specialityID,
          directoratedepartment,
          directorateID,            
          effectiveDate,
          reviewDate,
          comment,
          salutation,
        }).unwrap();
        dispatch(setCredentials({ ...res }));
        navigate(redirect);
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Container fluid>
      <h1>Register</h1>

      {isLoadingBC || isLoadingD || isLoadingM ? (
        <Loader />
      ) : errorM ? (
        <Message variant='danger'>{errorM.data.message}</Message>
      ) : (
        <Form onSubmit={submitHandler}>

          <Form.Group controlId='userType'>
  <Form.Label>Registering as</Form.Label>
  <Form.Control
    as='select'
    value={userType}
    onChange={(e) => setUserType(e.target.value)}
    style={textStyle}
  >
    <option value='staff'>Staff Member</option>
    <option value='agency'>Agency</option>
  </Form.Control>
</Form.Group>


          <Row>
            {/* First Column */}
            {/* Group Title, First Name, and Last Name on the same line */}
            <Col md={5}>
              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F0F8FF',
                }}
              >
                <Row>
                  <Col sm={2}>
                    <Form.Group controlId='salutation'>
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        as='select'
                        value={salutation}
                        onChange={(e) => setSalutation(e.target.value)}
                        style={textStyle}
                      >
                        <option value=''>Select Title</option>
                        <option value='Cllr.'>Cllr.</option>
                        <option value='Mr.'>Mr.</option>
                        <option value='Ms.'>Ms.</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Miss'>Miss</option>
                        <option value='Dr.'>Dr.</option>
                        <option value='Professor'>Professor</option>
                        <option value='Mx'>Mx</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col sm={5}>
                    <Form.Group controlId='firstname'>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter First Name'
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>

                  <Col sm={5}>
                    <Form.Group controlId='lastname'>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter Last Name'
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group controlId='email'>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type='email'
                    placeholder='Enter Email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={textStyle}
                  />
                </Form.Group>

                <Row>
                  <Col sm={6}>
                    <Form.Group controlId='employeenumber'>
                      <Form.Label>Employee Number</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter Employee Number'
                        value={employeenumber}
                        onChange={(e) => setEmployeenumber(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId='jobtitle'>
                      <Form.Label>Job Title</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Enter Job Title'
                        value={jobtitle}
                        onChange={(e) => setJobtitle(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <Form.Group controlId='effectiveDate'>
                      <Form.Label>Effective Date</Form.Label>
                      <Form.Control
                        type='date'
                        value={effectiveDate}
                        onChange={(e) => setEffectiveDate(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId='reviewDate'>
                      <Form.Label>Review Date </Form.Label>
                      <Form.Control
                        type='date'
                        placeholder='Review Date '
                        value={reviewDate} // {effectiveDate.toISOString().split('T')[0]}  //{effectiveDate}
                        onChange={(e) => setReviewDate(e.target.value)}
                        style={textStyle}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              <div>
                <p></p>
              </div>

              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F0F8FF',
                }}
              >
                <Form.Group className='my-2' controlId='password'>
                  <Form.Label>Change Password</Form.Label>
                  <Form.Control
                    type='password'
                    placeholder='Set password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={textStyle}
                  ></Form.Control>
                </Form.Group>

                <Form.Group className='my-2' controlId='confirmPassword'>
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type='password'
                    placeholder='Confirm password'
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={textStyle}
                  ></Form.Control>
                </Form.Group>
              </div>
            </Col>

            {/* Further sections for additional information */}
            {/* Second Column **************************************************************************************/}
            <Col md={4}>
              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F0F8FF',
                }}
              >
                {/* Add other form groups as needed, structured in a similar way */}
                

                <Form.Group controlId='setDirectorate'>
                  <Form.Label>Directorate</Form.Label>
                  <Form.Control
                    as='select'
                    placeholder='Directorate'
                    value={directoratedepartment}
                    //onChange={(e) => setActivityName(e.target.value)} style={dropdownStyle}
                    onChange={(e) => {
                      setDirectoratedepartment(e.target.value);
                      const selectedIndex = e.target.selectedIndex;
                      const selectedID =
                        e.target.options[selectedIndex].getAttribute('data-id');
                      setDirectorateID(selectedID);
                    }}
                    style={textStyle}
                  >
                    <option value={directoratedepartment}>
                      {directoratedepartment}
                    </option>

                    {directoratesdata &&
                      directoratesdata
                        .slice() // Create a shallow copy of the array to avoid mutating the original array
                        .sort((a, b) =>
                          a.directorate.localeCompare(b.directorate)
                        ) // Sort by activityName
                        .map((directorateList) => (
                          <option
                            key={directorateList._id}
                            value={`${directorateList.directorate}`}
                            data-id={directorateList._id}
                          >
                            {directorateList.directorate}
                          </option>
                        ))}
                  </Form.Control>
                </Form.Group>

                

                <Form.Group controlId='CostCentre'>
                  <Form.Label>Ward-Department normally assigned to</Form.Label>
                  <Form.Control
                    as='select'
                    placeholder='Speciality'
                    value={speciality}
                    //onChange={(e) => setActivityName(e.target.value)} style={dropdownStyle}
                    onChange={(e) => {
                      setSpeciality(e.target.value);

                      const selectedIndex = e.target.selectedIndex;
                      const selectedID =
                        e.target.options[selectedIndex].getAttribute('data-id');
                      setSpecialityID(selectedID);
                    }}
                    // style={{ width: '200px', flexBasis: 'calc(90% - 5px)', marginBottom: '10px' }}
                    style={textStyle}
                  >
                    <option value={speciality}>{speciality}</option>

                    {costcentresdata &&
                      costcentresdata
                        .slice() // Create a shallow copy of the array to avoid mutating the original array
                        .sort((a, b) =>
                          a.speciality.localeCompare(b.speciality)
                        ) // Sort by activityName
                        .map((costcentreList) => (
                          <option
                            key={costcentreList._id}
                            value={`${costcentreList.speciality}`}
                            data-id={costcentreList._id}
                          >
                            {costcentreList.speciality}
                          </option>
                        ))}
                  </Form.Control>
                </Form.Group>
                

                

                {/* Add other fields for the second column */}

                {/* Add other fields for the first column */}
              </div>
            </Col>

            {/* Further sections for additional information */}
            {/* Third Column **************************************************************************************/}
            <Col md={3}>
              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F0F8FF',
                }}
              >
                {/* Add other form groups as needed, structured in a similar way */}
                
               

              {/* Further sections for additional information */}
              {/* radiation Column **************************************************************************************/}

              <div
                style={{
                  border: '1px solid #ddd',
                  padding: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F0F8FF',
                }}
              >
                   
                  <Form.Group className='my-2' controlId='comment'>
                    <Form.Label>Comments</Form.Label>
                    <Form.Control
                      as='textarea' // Set the 'as' prop to 'textarea' for multiline text entry
                      rows={3} // Specify the number of visible text rows
                      placeholder='Comments'
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      style={textStyle}
                    />
                  </Form.Group>
                </div>
              </div>
            </Col>
          </Row>

          <Button disabled={isLoading} type='submit' variant='primary'>
            Register
          </Button>

          {isLoading && <Loader />}
        </Form>
      )}

      <Row className='py-3'>
        <Col>
          Already have an account?{' '}
          <Link to={redirect ? `/login?redirect=${redirect}` : '/login'}>
            Login
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterScreen;
